import { c as _c } from "react/compiler-runtime";
type PollProps = {
  id: string;
  label?: string;
  bgColor: string;
  textColor: string;
};
export const Poll: React.FC<PollProps> = t0 => {
  const $ = _c(7);
  const {
    label: t1,
    bgColor,
    textColor
  } = t0;
  const label = t1 === undefined ? "Poll" : t1;
  const t2 = `inline-flex items-center gap-1.5 ${bgColor} ${textColor} px-3 py-1 rounded`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="w-4 h-4"><svg className="w-full h-full" viewBox="0 0 24 24" fill="currentColor"><rect x="4" y="4" width="16" height="3" rx="1" /><rect x="4" y="10" width="12" height="3" rx="1" /><rect x="4" y="16" width="14" height="3" rx="1" /></svg></div>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const t4 = `${textColor}  tracking-wide`;
  let t5;
  if ($[1] !== label || $[2] !== t4) {
    t5 = <span className={t4}>{label}</span>;
    $[1] = label;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t2 || $[5] !== t5) {
    t6 = <div className={t2}>{t3}{t5}</div>;
    $[4] = t2;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};